import styled from 'styled-components';

import { ModeType } from 'screens/Products/utils/enums/ModeType.enum';

interface ContentProps {
  listMode: ModeType;
}

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: stretch;
  flex: 1;
  justify-content: center;
  background-color: #f5f5f5;
  gap: 8px;
  padding: 16px;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
  flex-wrap: ${({ listMode }) =>
    listMode === ModeType.Grid ? 'wrap' : 'nowrap'};

  ${({ listMode }) =>
    listMode === ModeType.Grid &&
    `
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  `}

  &.empty-data {
    align-items: center;
    justify-content: center;
    align-content: center;
    min-height: 45vh;
  }
`;

export const TextLoadMore = styled.div`
  width: 100%;
  margin: 12px 0;
  text-align: center;
  p {
    color: #f78e1e;
  }
`;

export const LastRef = styled.div`
  width: 100%;
  background-color: transparent;
`;

export const HideContainer = styled.div`
  .image-gallery {
    display: none !important;
  }
`;

export const OldPaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
  background-color: #ffffff;
  padding: 8px 16px;
  align-items: center;
`;

export const PaginationInfo = styled.div`
  font-size: 0.875rem;
  font-weight: 400;

  > strong {
    font-size: 700;
  }
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PinnedFilter = styled.div`
  background: red;
  height: 100vh;
  width: 250px;
`;
